var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { omit } from "lodash";
import { useContext } from "react";
import { Icons } from "../components/icons";
import { IconsContext } from "../components/context/icons-context";
import { ArrowFilledCircleIcon } from "../components/elements/arrow-filled-circle-icon";
import { CalendarArrowIcon } from "../components/elements/calendar-arrow-icon";
import { ConnectionsIcon } from "../components/elements/connections-icon";
import { DottedChevronDownIcon } from "../components/elements/dotted-chevron-down-icon";
import { DottedChevronLeftIcon } from "../components/elements/dotted-chevron-left-icon";
import { DottedChevronRightIcon } from "../components/elements/dotted-chevron-right-icon";
import { DottedChevronRightSmallIcon } from "../components/elements/dotted-chevron-right-small-icon";
import { DottedChevronUpIcon } from "../components/elements/dotted-chevron-up-icon";
import { DottedDownloadIcon } from "../components/elements/dotted-download-icon";
import { DottedHamburgerIcon } from "../components/elements/dotted-hamburger-icon";
import { FacebookFilledCircleIcon } from "../components/elements/facebook-filled-circle-icon";
import { FlickrFilledCircleIcon } from "../components/elements/flickr-filled-circle-icon";
import { InstagramFilledCircleIcon } from "../components/elements/instagram-filled-circle-icon";
import { LinkedinFilledCircleIcon } from "../components/elements/linkedin-filled-circle-icon";
import { SessionBookmarkIcon } from "../components/elements/session-bookmark-icon";
import { SessionCalendarIcon } from "../components/elements/session-calendar-icon";
import { SessionChatTextIcon } from "../components/elements/session-chat-text-icon";
import { SessionClockIcon } from "../components/elements/session-clock-icon";
import { SessionCropIcon } from "../components/elements/session-crop-icon";
import { SessionMapPinIcon } from "../components/elements/session-map-pin-icon";
import { SessionPresenterIcon } from "../components/elements/session-presenter-icon";
import { SessionTagIcon } from "../components/elements/session-tag-icon";
import { TikTokFilledCircleIcon } from "../components/elements/tik-tok-filled-circle-icon";
import { TwitterFilledCircleIcon } from "../components/elements/twitter-filled-circle-icon";
import { WebFilledCircleIcon } from "../components/elements/web-filled-circle-icon";
import { YouTubeFilledCircleIcon } from "../components/elements/youtube-filled-circle-icon";
import { ChevronDownIcon } from "../components/icons/chevron-down-icon";
import { InfoCircleIcon } from "../components/icons/info-circle-icon";
import { Cluster } from "../components/icons/entities/cluster-icon";
import { Economy } from "../components/icons/entities/economy-icon";
import { Event } from "../components/icons/entities/event-icon";
import { ImpactResultType } from "../components/icons/entities/impact-result-type-icon";
import { Indicator } from "../components/icons/entities/indicator-icon";
import { KeyIssue } from "../components/icons/entities/key-issue-icon";
import { Organisation } from "../components/icons/entities/organisation-icon";
import { Person } from "../components/icons/entities/person-icon";
import { Sdg } from "../components/icons/entities/sdg-icon";
import { Video } from "../components/icons/entities/video-icon"; // TODO: eventually, we'll clean up this folder structure, but collecting these all together provides
// a consistent external API 

var singleIcons = omit(Icons, 'Sdg', 'Entities', 'Platforms', 'Social');
var otherIcons = {
  ArrowFilledCircleIcon: ArrowFilledCircleIcon,
  CalendarArrowIcon: CalendarArrowIcon,
  ConnectionsIcon: ConnectionsIcon,
  DottedChevronDownIcon: DottedChevronDownIcon,
  DottedChevronLeftIcon: DottedChevronLeftIcon,
  DottedChevronRightIcon: DottedChevronRightIcon,
  DottedChevronRightSmallIcon: DottedChevronRightSmallIcon,
  DottedChevronUpIcon: DottedChevronUpIcon,
  ChevronDownIcon: ChevronDownIcon,
  DottedDownloadIcon: DottedDownloadIcon,
  DottedHamburgerIcon: DottedHamburgerIcon,
  FacebookFilledCircleIcon: FacebookFilledCircleIcon,
  FlickrFilledCircleIcon: FlickrFilledCircleIcon,
  InstagramFilledCircleIcon: InstagramFilledCircleIcon,
  LinkedinFilledCircleIcon: LinkedinFilledCircleIcon,
  SessionBookmarkIcon: SessionBookmarkIcon,
  SessionCalendarIcon: SessionCalendarIcon,
  SessionChatTextIcon: SessionChatTextIcon,
  SessionClockIcon: SessionClockIcon,
  SessionCropIcon: SessionCropIcon,
  SessionMapPinIcon: SessionMapPinIcon,
  SessionPresenterIcon: SessionPresenterIcon,
  SessionTagIcon: SessionTagIcon,
  TikTokFilledCircleIcon: TikTokFilledCircleIcon,
  TwitterFilledCircleIcon: TwitterFilledCircleIcon,
  WebFilledCircleIcon: WebFilledCircleIcon,
  YouTubeFilledCircleIcon: YouTubeFilledCircleIcon
};
export var useIcons = function useIcons() {
  var contextIcons = useContext(IconsContext) || {};
  var entities = {
    ClusterIcon: Cluster,
    EconomyIcon: Economy,
    EventIcon: Event,
    IndicatorIcon: Indicator,
    ImpactResultTypeIcon: ImpactResultType,
    KeyIssueIcon: KeyIssue,
    OrganisationIcon: Organisation,
    PersonIcon: Person,
    SdgIcon: Sdg,
    VideoIcon: Video
  };
  return __assign(__assign(__assign(__assign({
    ChevronDownIcon: ChevronDownIcon,
    InfoCircleIcon: InfoCircleIcon
  }, singleIcons), entities), otherIcons), contextIcons);
};